import React from "react";
import {DashboardCard} from "@/ReactInit/Scripts/DashboardPage/components/DashboardCard";
import {DashboardLinkButton} from "@/ReactInit/Scripts/DashboardPage/components/DashboardButton";
import {DashboardAlertBox} from "@/ReactInit/Scripts/DashboardPage/components/DashboardAlertBox";
import {
  formatNorwegianPhone,
  norwegianNationalPhone
} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardFormatting";
import {useIsMobile} from "@/ReactInit/Scripts/DashboardPage/hooks/useBreakpoint";

export interface VippsUserInfo {
  isAuthenticated: boolean;
  phoneNumber?: string;
  producerName?: string;
  producerId?: string;
  email?: string;
  orgnr?: string;
  deactivated?: boolean;
}

interface UserInfoProps {
  user: VippsUserInfo | null;
  loginError: string | null;
  isAuthLoading: boolean;
}

const UserInfo: React.FC<UserInfoProps> = ({user, loginError, isAuthLoading}) => {
  const isAuthenticated = !!user?.isAuthenticated;

  if (isAuthLoading) return null;
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col gap-3 w-full mx-auto max-w-[932px]">
      {loginError && <DashboardAlertBox type="error" label={loginError}/>}
      {isAuthenticated ? (
        <div className="tablet:absolute tablet:top-3 tablet:right-4 tablet:z-50">
          <div className="flex items-center gap-2 justify-between tablet:justify-end">
            {user.phoneNumber && (
              <span className="mr-2 text-sm flex flex-row whitespace-nowrap items-center gap-1">
                <span>{isMobile ? "Logget inn:" : "Logget inn med"}</span>
              <span className="icon-phone hidden tablet:inline" aria-hidden="true"/>
                <span>{formatNorwegianPhone(norwegianNationalPhone(user.phoneNumber))}</span>
            </span>
            )}
            <DashboardLinkButton
              href="/api/auth/vippslogin"
              variant="darkplain"
              label="Logg ut"
              icon="icon-log-out"
              iconPosition="right"
              rounded="full"
              className="!text-sm"
              customPadding="!px-3.5 !py-1.5"
            />
          </div>
        </div>
      ) : (
        <DashboardCard as="section" size="vipps" className="flex flex-col items-center gap-5 tablet:gap-10">
          {!loginError && (
            <p className="text-3xl">
              Denne siden krever innlogging. Vennligst logg inn med Vipps
            </p>
          )}
          <DashboardLinkButton
            href="/api/auth/vippslogin"
            variant="vipps"
            label="Logg inn med Vipps"
            rounded="medium"
            className="min-h-11"
          />
        </DashboardCard>
      )}
    </div>
  );
};

export default UserInfo;
